import { render, staticRenderFns } from "./commodity-used.vue?vue&type=template&id=046d2bff&"
import script from "./commodity-used.vue?vue&type=script&lang=js&"
export * from "./commodity-used.vue?vue&type=script&lang=js&"
import style0 from "./commodity-used.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAutocomplete: require('/opt/cargo.front/src/components/base/autocomplete/index.vue').default})
